import { Action } from "../../../../common/enum";
import { OutletInput } from "../../components/OutletInput";

export default function OutletAddInput() {
  return (
    <OutletInput
      reviewRoute="/outlet/add/review"
      title="Outlet Add Input"
      action={Action.CREATE}
    />
  );
}
